import { useContext } from 'react';

import { useStore } from 'zustand';

import { RegexPatternsStoreContext } from '../providers/RegexPatternsProvider';
import type { RegexPatternsStore } from '../stores/regexPatternsStore';

function useRegexPatternsStore<T>(selector: (store: RegexPatternsStore) => T): T {
    const regexPatternsStoreContext = useContext(RegexPatternsStoreContext);

    if (!regexPatternsStoreContext) {
        throw new Error('useRegexPatternsStore must be used within RegexPatternsStoreProvider');
    }

    return useStore(regexPatternsStoreContext, selector);
}

export default useRegexPatternsStore;
